// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type DeleteEmployeeEmergencyContactMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type DeleteEmployeeEmergencyContactMutation = { __typename?: 'Mutation' } & Pick<
  Types.Mutation,
  'deleteEmployeeEmergencyContact'
>;

export const DeleteEmployeeEmergencyContactDocument = /*#__PURE__*/ gql`
    mutation deleteEmployeeEmergencyContact($id: ID!) {
  deleteEmployeeEmergencyContact(id: $id)
}
    `;
export type DeleteEmployeeEmergencyContactMutationFn = Apollo.MutationFunction<
  DeleteEmployeeEmergencyContactMutation,
  DeleteEmployeeEmergencyContactMutationVariables
>;

/**
 * __useDeleteEmployeeEmergencyContactMutation__
 *
 * To run a mutation, you first call `useDeleteEmployeeEmergencyContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmployeeEmergencyContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmployeeEmergencyContactMutation, { data, loading, error }] = useDeleteEmployeeEmergencyContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEmployeeEmergencyContactMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteEmployeeEmergencyContactMutation,
    DeleteEmployeeEmergencyContactMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteEmployeeEmergencyContactMutation, DeleteEmployeeEmergencyContactMutationVariables>(
    DeleteEmployeeEmergencyContactDocument,
    options,
  );
}
export type DeleteEmployeeEmergencyContactMutationHookResult = ReturnType<
  typeof useDeleteEmployeeEmergencyContactMutation
>;
export type DeleteEmployeeEmergencyContactMutationOptions = Apollo.BaseMutationOptions<
  DeleteEmployeeEmergencyContactMutation,
  DeleteEmployeeEmergencyContactMutationVariables
>;
